module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/bg1-11aaa658d65bf3b122f848cad959ae8e.jpg";